import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../helpers/reducerRegistry'

const slice = createSlice({
  name: 'companyAnalysis/industryAnalysis',
  initialState: {
    isFirstLoad: false,
    defaultIndustry: undefined,
    compareIndustry: undefined,
    currentMainVsicId: undefined,
  },
  reducers: {
    changeIndustry: (state, action) => {
      state.isFirstLoad = true
      state[action.payload.type] = action.payload.value
    },
    resetForNewCompany: (state, action) => {
      state.isFirstLoad = true
      state.defaultIndustry = action.payload.defaultIndustry
      state.compareIndustry = undefined
      state.currentMainVsicId = action.payload.mainVsicId
    },
  },
})

register(slice.name, slice.reducer)

export const { changeIndustry, resetForNewCompany } = slice.actions

export const selectIndustryAnalysisState = (state) => state[slice.name]
export const selectDefaultIndustry = (state) =>
  state[slice.name].defaultIndustry
export const selectCompareIndustry = (state) =>
  state[slice.name].compareIndustry
export const selectIsFirstLoad = (state) => state[slice.name].isFirstLoad
export const selectCurrentMainVsicId = (state) =>
  state[slice.name].currentMainVsicId
